import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedMedianCalculator from "./SharedMedianCalculator";
const TITLE = "حاسبة الوسيط الالكترونية - احسب رتبة الوسيط";
const DESCRIPTION =
  "حاسبة الوسيط الإحصائي: احسب قيمة الوسيط وموقعه بدقة مع شرح خطوات الحساب خطوة بخطوة! أدخل مجموعة البيانات الخاصة بك (أرقام، درجات، قياسات) لمعرفة الرتبة الوسيطية والنتيجة - أداة مثالية للتحليل الإحصائي والبحوث العلمية.";
const KEYWORDS = "احسب رتبة الوسيط";
const OG_URL = "https://do-calculate.com/calculator/ar/median/";
function Calculator() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                الوسيط : هو أحد مقاييس النزعة المركزية في علم الإحصاء حيث من
                خلاله يتم احتساب القيمة التي تقع في وسط البيانات بشرط أن يكون
                عدد القيم التي أقل منها مساويا للقيم التي أكبر متها .
                <br />
                <ul>
                  <li>١. نرتب البيانات تصاعديا أو تنازليا .</li>
                  <li>
                    ٢. إذا كان عدد البيانات فرديا يكون الوسيط عبارة عن القيمة
                    التي رتبتها ( عدد البيانات + ١ ) ÷ ٢ أي أن الوسيط يساوي (
                    n+1/2) .
                  </li>
                  <li>
                    ٣. إذا كان عدد البيانات زوجيا يكون الوسيط متوسط القيمتين
                    الذين رتبتهما هي ( n/2 ) و ( n +2 /2 ).
                  </li>
                </ul>
                <b>
                  يمكنك أيضا استخدام الحاسبة الالكترونية التالية لحساب قيمة
                  الوسيط:
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <SharedMedianCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
